import React, { useCallback, useEffect } from 'react';
import styles from '../index.module.sass';
import Button from 'components/button';
import OnBoardingLayout from 'layout/onboarding';
import {
  useLoginFlowContext,
  CHANGE_CAR_TYPE,
  CHANGE_ENERGY_SOURCE_TYPE,
  CHANGE_PLATE_NUMBER,
  CHANGE_PLATE_NUMBER_ERROR_MESSAGE,
} from '../use-login-flow';
import { LICENSE_PLATE_TYPES } from 'model/license-plate';
import amplitude from 'service/amplitude';
import PlateNumberForm from 'module/plate-number-form';
import { isNpcpay } from 'config';
import RentalPlateDialog from 'components/rental-plate-dialog';

const AddPlateNumberPage = () => {
  const { state, dispatch, addPlateNumber, redirectAfterAddPlate } = useLoginFlowContext();

  useEffect(() => {
    amplitude.addPlateNumber_pageview();
  }, []);

  useEffect(() => {
    return () => {
      dispatch({
        type: CHANGE_PLATE_NUMBER_ERROR_MESSAGE,
        payload: '',
      });
    };
  }, [dispatch]);

  const onPlateNumberChanged = useCallback(
    plateNumber => {
      dispatch({
        type: CHANGE_PLATE_NUMBER,
        payload: plateNumber,
      });
    },
    [dispatch]
  );

  const onCarTypeChanged = useCallback(
    carType => {
      amplitude.addPlateNumber_vehicleType_onClick(LICENSE_PLATE_TYPES.find(type => type.key === carType).value);
      dispatch({
        type: CHANGE_CAR_TYPE,
        payload: carType,
      });
    },
    [dispatch]
  );

  const onEnergySourceChange = useCallback(
    energySourceType => {
      dispatch({
        type: CHANGE_ENERGY_SOURCE_TYPE,
        payload: energySourceType,
      });
    },
    [dispatch]
  );

  const onAddPlateNumber = useCallback(() => {
    amplitude.addPlateNumber_button_onClick({
      plateNumber: state.plateNumber,
      type: LICENSE_PLATE_TYPES.find(type => type.key === state.carType).value,
    });
    addPlateNumber(state.plateNumber, state.carType);
  }, [state.plateNumber, state.carType, addPlateNumber]);

  return (
    <OnBoardingLayout className={styles['add-plate-number']}>
      <RentalPlateDialog
        show={state.showRentalPlateDialog}
        onShow={amplitude.addplateNumber_rental_dialog_pageview}
        onClick={() => {
          amplitude.addPlateNumber_rental_dialog_confirm_onClick();
          redirectAfterAddPlate();
        }}
      />
      <div className={styles.top}>
        <ul className={styles.progress}>
          <li className={styles.active}>1</li>
          <li className={styles.active}>2</li>
          <li>3</li>
        </ul>
        <PlateNumberForm
          title="加入付款車牌"
          plateNumber={state.plateNumber}
          plateNumberErrorMessage={state.plateNumberErrorMessage}
          onPlateNumberFocus={() => amplitude.addPlateNumber_plateNumber_onClick()}
          onPlateNumberChange={onPlateNumberChanged}
          onEnergySourceChange={onEnergySourceChange}
          energySource={state.energySourceType}
          carType={state.carType}
          onCarTypeChanged={onCarTypeChanged}
        />
      </div>
      <div className={styles.bottom}>
        <Button theme="blue" block={true} loading={state.loading} onClick={onAddPlateNumber}>
          設定好了
        </Button>
        {isNpcpay && <div className={styles['npc-hint']}>「台北市公有停車場」隔日才能使用自動扣款出場</div>}
      </div>
    </OnBoardingLayout>
  );
};

export default AddPlateNumberPage;
